import { UserType } from '@tyro/api';

export const DEFAULT_WHATS_NEW_PAGE_LIMIT = 20;

export const getWhatsNewItemDetailsPath = (id: number) =>
  `/items/whats_new_web/${id}`;
export const getWhatsNewListPath = (userType: UserType, page: number) => {
  const filterParams =
    userType === UserType.Tyro
      ? '&filter[status][_neq]=archived'
      : `&filter[status]=published&filter[filter_usertype][_contains]=${userType}`;
  return `/items/whats_new_web?limit=${DEFAULT_WHATS_NEW_PAGE_LIMIT}&fields[]=title&fields[]=preview_image&fields[]=id&fields[]=summary&fields[]=published_date&fields[]=filter_permissions&sort[]=-published_date&page=${page}${filterParams}`;
};
